import React from "react";
import styles from "./style.scss";
import { Source } from "./Source";
import { Dialog } from "./Dialog";
import { Chat as ChatType, DownloadType, Reference } from "models/AiResearch";

interface Props {
  chat: ChatType;
  selectedReference?: Reference | null;
  handleSelectRecommendation: (text: string) => void;
  handleShowReference: ({
    questionId,
    referenceId
  }: {
    questionId: string;
    referenceId: number;
  }) => void;
  handleCopy: ({ chatIndex }: { chatIndex: number }) => void;
  handleDownload: ({
    type,
    questionId
  }: {
    type: DownloadType;
    questionId: string;
  }) => void;
}

export const Chat: React.FC<Props> = ({
  chat,
  selectedReference,
  handleSelectRecommendation,
  handleShowReference,
  handleCopy,
  handleDownload
}) => {
  return (
    <div className={styles.wrapper}>
      <Source title={chat.history?.[0]?.question ?? ""} />
      <Dialog
        chat={chat}
        selectedReference={selectedReference}
        handleSelectRecommendation={handleSelectRecommendation}
        handleShowReference={handleShowReference}
        handleCopy={handleCopy}
        handleDownload={handleDownload}
      />
    </div>
  );
};
